import { useEffect, useRef, useState } from 'react'

interface ObserverOptions extends MutationObserverInit {
    onObserve?: () => void
    /**
     * Exclude targets from the observer - class or id
     */
    excludeTargets?: string[]
}

const useMutationObserver = (target: HTMLElement, callback: MutationCallback, options?: ObserverOptions): void => {
    const [internalOptions] = useState<ObserverOptions>(options ?? {})
    const cb = useRef<MutationCallback>(callback)
    cb.current = callback

    useEffect(() => {
        const observer = new MutationObserver((...a) => {
            if (!cb.current) return

            let shouldTrigger = true
            if (internalOptions?.excludeTargets) {
                shouldTrigger = !a[0].some(mutation => {
                    const el = mutation.target as HTMLElement

                    return internalOptions?.excludeTargets?.some(id => el.closest(`.${id}`) || el.closest(`#${id}`))
                })
            }

            shouldTrigger && cb.current?.(...a)
        })

        if (target) {
            observer.observe(target, internalOptions)
            internalOptions?.onObserve?.()
        }

        return () => observer.disconnect()
    }, [target, internalOptions])
}

export default useMutationObserver
